<div class="min-vh-100 py-4 d-flex align-items-center justify-content-center pt-10 pt-md-0">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12 col-md-6 pe-md-6">
                <div class="left-text">
                    <a class="a--border-off d-flex back-link"
                       tabindex="0"
                       [routerLink]="[routeEntity.Root, routeEntity.Login]"
                       [attr.title]="'app.actions.login' | translate">
                        <mat-icon fontIcon="keyboard_backspace" class="me-2" />
                        {{ 'app.actions.login' | translate }}</a>

                    <h1 class="title">
                        {{ 'auth.register.page_title' | translate }}
                    </h1>

                    @let text = communicationChannelsText$ | async;
                    @if (text) {
                        <div class="subtitle mb-6">
                            <p>{{ text.message }}</p>
                        </div>
                    }
                </div>
            </div>
            <div class="col-12 col-md-6 ps-md-6">
                @if (!(loggedIn$ | async)) {
                    <app-register-form (errorRecaptcha)="handlerErrorRecaptcha()"
                                       [settings]="settings$ | async"
                                       [pending]="pending$ | async"
                                       [error]="error$ | async"
                                       [channels]="communicationChannels$ | async"
                                       [countryCodes]="countryCodes$ | async"
                                       [defaultCode]="defaultCode$ | async"
                                       [regions]="regions$ | async"
                                       (submitted)="onSubmit($event)" />
                }
            </div>
        </div>
    </div>
</div>
